import { EconomicsCalculationsAnnualValueBase } from './base/economics-calculations-annual-value-base';

export class EconomicsCalculationsAnnualValue extends EconomicsCalculationsAnnualValueBase { }